import { Box } from '@mui/system';
import { FC, useState } from 'react';
import { ITemplateDTO, createTemplate } from 'wisestep-api';
import { Layout, WsDrawer, WsDrawerProps, IUserDTO } from 'wisestep-base';

import { useSKUModalStore } from '../../../../components/skuModal/SKUModalStore';
import { useUserContext } from '../../../../context';
import { MULTIPLE_SUBMISSION_TEMPLATES } from '../../../../features/templateSettings/helper/constants';
import { warning, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

import AssignTemplate from './AssignTemplate';
import CreateTemplateEditor from './CreateTemplateEditor';

export interface CreateTemplateProps {
  openDialog: boolean;
  closeDialog(): void;
  onEditOrCloneTemplate?: ITemplateDTO;
  onCloneTemplate?: ITemplateDTO;
  variant: 'new' | 'edit' | 'clone';
  refreshData(): void;
  templateType?: string;
}
const CreateTemplate: FC<CreateTemplateProps> = ({
  openDialog,
  closeDialog,
  onEditOrCloneTemplate,
  variant,
  refreshData,
  templateType,
}) => {
  const setModal = useSKUModalStore((state) => state.setModal);
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [drawerPage, setDrawerPage] = useState<WsDrawerProps['size']>('full');
  const [formDataOne, setFormDataOne] = useState<ITemplateDTO>();
  const onSaveTemplateHandler = (templateConfig: ITemplateDTO) => {
    if (variant === 'edit') {
      templateConfig.teamIds = onEditOrCloneTemplate?.teamIds;
    } else {
      templateConfig.teamIds = [];
    }
    setFormDataOne(templateConfig);
    setDrawerPage('small');
  };

  const onAssign = async (templateData?: ITemplateDTO) => {
    if (!formDataOne) {
      return;
    }

    formDataOne.templateType = templateType || formDataOne.templateType;

    if (variant === 'edit' && onEditOrCloneTemplate?.recruiterId != null) {
      formDataOne.recruiterId = onEditOrCloneTemplate?.recruiterId;
    } else if (variant === 'edit') {
      formDataOne.recruiterId = loggedInUser.email;
    }

    if (templateData?.teamIds) {
      formDataOne.teamIds = templateData.teamIds;
    }

    try {
      if (templateType == MULTIPLE_SUBMISSION_TEMPLATES) {
        const bodyHeader = formDataOne.body
          ?.slice(0, formDataOne.body?.indexOf('<table'))
          .toString();

        const bodyFooter = formDataOne.body
          ?.slice(formDataOne.body?.indexOf('</table>'))
          .toString();

        formDataOne.body = bodyHeader + '{{tableContent}} ' + bodyFooter;
      }
      const response = await createTemplate(formDataOne);
      setFormDataOne(response.data);
      setNotification(
        success(
          variant === 'new'
            ? 'Template Created Successfully'
            : variant === 'clone'
            ? 'Template Created Successfully'
            : 'Template Edited Successfully'
        )
      );
      closeDialog();
      refreshData();
    } catch (error: any) {
      if (error.response.status == 402) {
        setModal({ object: error.response.data, type: 'count' });
      }
      setNotification(warning('Something Went Wrong, Please try again'));
    }
  };

  return (
    <Box>
      <WsDrawer
        size={drawerPage}
        open={openDialog}
        onClose={() => closeDialog()}
        iconType="arrow"
        title={drawerPage === 'full' ? 'Create Template' : 'Share Template'}
      >
        <Layout>
          {drawerPage === 'full' && (
            <CreateTemplateEditor
              onSaveTemplate={onSaveTemplateHandler}
              onEditOrCloneTemplate={onEditOrCloneTemplate}
              variant={variant}
              type={templateType}
            />
          )}
          {drawerPage === 'small' && formDataOne && (
            <AssignTemplate
              variant={variant}
              onSkip={onAssign}
              formData={formDataOne}
              teamsIDs={onAssign}
            />
          )}
        </Layout>
      </WsDrawer>
    </Box>
  );
};
export default CreateTemplate;
